<template>
  <div v-if="orderDetails.data.length" class="space-y-2">
    <div class="flex items-center justify-between">
      <dt class="text-xs text-gray-700">{{ type === 'all' ? 'Barang' : 'Barang Susulan' }}</dt>
      <BaseInput size="sm" type="text" placeholder="Cari barang" :shadow="false" debounce v-model="filter.search" @native-input="loadOrderDetails" />
    </div>
    <Datatable
      :scroll-x="true"
      :total="orderDetails.meta.page.total"
      :perPage="orderDetails.meta.page.perPage"
      :currentPage="orderDetails.meta.page.currentPage"
      compact
      @pagechanged="onChangePage"
      :columns="
        [
          { id: 'code', name: 'Kode Barang' },
          { id: 'qty', name: 'Jumlah', theadClass: 'text-right' },
          columns.includes('packed_qty')
            ? {
                id: 'packed_qty',
                name: 'Dikirim',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('unpacked_qty')
            ? {
                id: 'unpacked_qty',
                name: 'Belum Dikirim',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('price')
            ? {
                id: 'price',
                name: 'Harga Barang',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('weight')
            ? {
                id: 'price',
                name: 'Berat',
                theadClass: 'text-right',
              }
            : null,
          this.type === 'all' ? {
            id: 'total_price',
            name: 'Total Harga',
            theadClass: 'text-right',
          } : null,
          columns.includes('pv')
            ? {
                id: 'pv',
                name: 'PV',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('bv')
            ? {
                id: 'bv',
                name: 'BV',
                theadClass: 'text-right',
              }
            : null,
          columns.includes('total_weight')
            ? {
                id: 'total_weight',
                name: 'Total Berat',
                theadClass: 'text-right',
              }
            : null,
        ].filter((item) => !!item)
      "
    >
      <template #tbody="{ classes }">
        <tr
          v-for="(orderDetail, index) in orderDetails.data"
          :key="index"
          :class="classes.tr"
        >
          <td :class="[classes.td]">
            <p class="font-bold text-gray-900">
              {{ orderDetail.attributes.product_code }}
              <span v-if="orderDetail.attributes.product_type === 'free'"
                >(Promo)</span
              >
            </p>
          </td>
          <td :class="[classes.td, 'text-right']">
            <p v-if="type === 'all'">
              {{ orderDetail.attributes.product_qty | toCurrency }}
            </p>
            <p v-else>
              {{
                (orderDetail.attributes.product_qty -
                  orderDetail.attributes.product_shipped_qty)
                  | toCurrency
              }}
            </p>
          </td>
          <td
            v-if="columns.includes('packed_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{ orderDetail.attributes.product_shipped_qty | toCurrency }}
          </td>
          <td
            v-if="columns.includes('unpacked_qty')"
            :class="[classes.td, 'text-right']"
          >
            {{
              (orderDetail.attributes.product_qty -
                orderDetail.attributes.product_shipped_qty)
                | toCurrency
            }}
          </td>
          <td
            v-if="columns.includes('weight')"
            :class="[classes.td, 'text-right']"
          >
            {{ orderDetail.attributes.product_weight | toCurrency }}
          </td>
          <td
            v-if="columns.includes('price')"
            :class="[classes.td, 'text-right']"
          >
            {{ orderDetail.attributes.product_price | toCurrency }}
          </td>
          <td v-if="type === 'all'" :class="[classes.td, 'text-right']">
            {{ (displayDefaultAreaPrice ? orderDetail.attributes.total_default_area_price : orderDetail.attributes.total_price) | toCurrency }}
          </td>
          <td v-if="columns.includes('pv')" :class="[classes.td, 'text-right']">
            {{ orderDetail.attributes.point_value | toCurrency }}
          </td>
          <td v-if="columns.includes('bv')" :class="[classes.td, 'text-right']">
            {{ orderDetail.attributes.bonus_value | toCurrency }}
          </td>
          <td
            v-if="columns.includes('total_weight')"
            :class="[classes.td, 'text-right']"
          >
            {{ orderDetail.attributes.total_weight | toCurrency }}
          </td>
        </tr>
      </template>
      <template v-if="order && type === 'all'" v-slot:tfoot="{ classes }">
        <tfoot>
          <tr
            v-if="order.data.attributes.discount_price"
            :class="classes.tr"
          >
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'text-right']">Total Potongan</td>
            <td :class="[classes.td, 'text-right']">
              {{ order.data.attributes.discount_price | toCurrency }}
            </td>
          </tr>
          <tr :class="classes.tr">
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'text-right', order.data.attributes.discount_price ? 'pt-0' : '']">Total Penjualan</td>
            <td :class="[classes.td, 'text-right', order.data.attributes.discount_price ? 'pt-0' : '']">
              {{ (displayDefaultAreaPrice ? order.data.attributes.default_area_price : order.data.attributes.grand_total_price) | toCurrency }}
            </td>
          </tr>
          <tr
            v-if="withPayment && order.data.attributes.is_using_stock"
            :class="classes.tr"
          >
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'pt-0 text-right']">Total Pembayaran</td>
            <td :class="[classes.td, 'pt-0 text-right']">
              {{ order.data.attributes[order.data.attributes.is_valid_for_payment ? 'cashier_payment_amount' : 'payment_amount'] | toCurrency }}
            </td>
          </tr>
          <tr
            v-if="withPayment && order.data.attributes.is_using_stock"
            :class="classes.tr"
          >
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'pt-0 text-right']">Total Kekurangan</td>
            <td :class="[classes.td, 'pt-0 text-right']">
              {{
                Math.max(
                  order.data.attributes.grand_total_price -
                    order.data.attributes[order.data.attributes.is_valid_for_payment ? 'cashier_payment_amount' : 'payment_amount'],
                  0
                ) | toCurrency
              }}
            </td>
          </tr>
          <tr
            v-if="
              withShippingFee &&
              order.data.attributes.order_shipment === 'delivery'
            "
            :class="classes.tr"
          >
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'pt-0 text-right']">Selisih</td>
            <td :class="[classes.td, 'pt-0 text-right']">
              {{ order.data.attributes.shipping_fee | toCurrency }}
            </td>
          </tr>
          <tr
            v-if="
              withShippingFee &&
              order.data.attributes.order_shipment === 'delivery'
            "
            :class="classes.tr"
          >
            <td colspan="2"></td>
            <td v-if="columns.includes('packed_qty')"></td>
            <td v-if="columns.includes('unpacked_qty')"></td>
            <td :class="[classes.td, 'pt-0 text-right']">Plastik</td>
            <td :class="[classes.td, 'pt-0 text-right']">
              {{ order.data.attributes.plastic_qty | toCurrency }}
            </td>
          </tr>
        </tfoot>
      </template>
    </Datatable>
  </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    type: {
      type: String,
      default: 'all',
    },
    columns: {
      type: Array,
      default: () => ['code', 'qty', 'price', 'total_price'],
    },
    orderId: String,
    order: Object,
    withPayment: {
      type: Boolean,
      default: true,
    },
    withShippingFee: Boolean,
    displayDefaultAreaPrice: Boolean
  },
  emits: ['update-loading', 'load'],
  data() {
    return {
      filter: {
        search: null
      },
      loading: false,
      orderDetails: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  methods: {
    async loadOrderDetails(params) {
      this.$emit('update-loading', true);

      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/order-details`,
        {
          params: {
            'page[size]': 5,
            'fields[order-details]]':
              'product_code,product_qty,product_packed,product_received,product_shipped_qty,product_weight,product_price,total_price,total_default_area_price,product_type,point_value,bonus_value,total_weight',
            'filter[search]': this.filter.search,
            ...(this.type === 'all' ? {} : { 'filter[completed]': false }),
            ...params
          },
        }
      );

      if (!err) {
        this.orderDetails = res;
      }

      this.$emit('update-loading', false);
    },
    onChangePage(page) {
      this.loadOrderDetails({
        'page[number]': page
      })
    }
  },
  async created() {
    await this.loadOrderDetails();

    this.$emit('load', { hasItems: this.orderDetails.data.length })
  },
};
</script>
